import { useState } from 'react'
import { platformAlternateBg } from '../PlatformShared'
import { pricingContainer, pricingSection, PricingHeading } from './Shared'

export default function PricingFaq({ data }) {
    const [openId, setOpenId] = useState(data.items[0]?.id)
    return (
        <section className={`${pricingSection} ${platformAlternateBg}`}>
            <div className={pricingContainer}>
                <PricingHeading title={data.title} />
                <div className="mx-auto max-w-[860px]">
                    {data.items.map((item) => (
                        <div
                            key={item.id}
                            className="border-b border-black/10 py-[22px]">
                            <h3>
                                <button
                                    id={`${item.id}-question`}
                                    type="button"
                                    aria-expanded={openId === item.id}
                                    aria-controls={`${item.id}-answer`}
                                    onClick={() =>
                                        setOpenId(
                                            openId === item.id ? null : item.id,
                                        )
                                    }
                                    className="flex w-full items-center justify-between gap-4 text-left text-[15px] font-bold focus-visible:outline-primary">
                                    {item.question}
                                    <span
                                        aria-hidden="true"
                                        className={`text-xl text-secondary transition-transform ${
                                            openId === item.id
                                                ? 'rotate-45'
                                                : ''
                                        }`}>
                                        +
                                    </span>
                                </button>
                            </h3>
                            <div
                                id={`${item.id}-answer`}
                                role="region"
                                aria-labelledby={`${item.id}-question`}
                                hidden={openId !== item.id}>
                                <p className="mt-3 max-w-[700px] text-sm leading-relaxed text-olm-gray">
                                    {item.answer}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
